export default "__VITE_ASSET__LLi0NxUc__"